var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kvsync-webhook"},[_c('h2',[_vm._v("Danh sách webhook")]),_vm._v(" "),_c('b-table',{attrs:{"bordered":"","striped":"","hover":"","items":_vm.webhooks}}),_vm._v(" "),_c('button',{on:{"click":function($event){return _vm.backToConfig()}}},[_vm._v("Trở về trang đồng bộ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60692320","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/webhook/WebHook.vue
// module id = null
// module chunks = 